import React from "react";

import Utils from "@/legacy/Utils.js";
import {checkFeatures} from "@/pages/rum/v2/CheckFeatures.js";
import {getBaselineComparison, renderBaselineComparison} from "@/pages/rum/v2/RumUtils.jsx";

import "./RUMDataDetail.css";

class RUMDataDetail extends React.Component {
  constructor(props) {
    super(props);
    Utils.autoBindClass(this);
  }

  render() {
    const {primary, details, title, tooltip} = this.props.data || {};
    const data = this.props.data.data || {};

    // Format large numbers to be more readable in some cases.
    const precisions = {
      [checkFeatures.pageViews.key]: 4,
      [checkFeatures.sessions.key]: 4,
      [checkFeatures.errorRate4xx.key]: 2,
      [checkFeatures.errorRate5xx.key]: 2,
      [checkFeatures.errorRateJS.key]: 2,
    };
    const intThreshold = 10000;

    // Make primary detail large, bold, and without the text to the left.
    let primaryComparison, primaryCompData;
    if (primary && (primary === checkFeatures.pageViews || data[primary.key])) {
      primaryCompData = getBaselineComparison(primary, data, {
        valuePrecision: precisions[primary.key],
        intThreshold,
        isAjax: this.props.isAjax,
      });
      primaryComparison = renderBaselineComparison(primaryCompData, {
        headerStyle: {fontSize: "22px", fontWeight: 600},
        arrowStyle: {fontSize: "14px"},
      });
    }

    // Make secondary detais smaller and with line dividers.
    const detailRows = [];
    if (details) {
      for (const feature of details) {
        const comparisonData = getBaselineComparison(feature, data, {
          valuePrecision: precisions[feature.key] || 3,
          intThreshold,
          isAjax: this.props.isAjax,
        });
        const detailComparison = renderBaselineComparison(comparisonData);

        detailRows.push(
          <div key={feature.key} className="detail-row d-flex align-items-end" title={comparisonData.title}>
            <span className="fs-7 me-2">{feature.name}</span>
            <span className="" style={{flexGrow: 1, borderBottom: "dotted 1px gray"}}></span>
            <span className="ms-2">{detailComparison}</span>
          </div>
        );
      }
    }

    // If no page views, display a note to the user about what to do.
    const pageViewsValue = data ? data[checkFeatures.pageViews.key] || data[checkFeatures.ajaxViews.key] : 0;
    let userNote;
    if (primary && primary === checkFeatures.pageViews && pageViewsValue === 0) {
      userNote = (
        <p className="no-views-note">
          Try expanding time range, or see
          <a
            href="https://support.uptime.com/hc/en-us/articles/115002559485-Overview-of-RUM-Checks-Reports"
            target="_blank"
          >
            &nbsp;here&nbsp;
          </a>
          for more ideas.
        </p>
      );
    }

    const detailTitle = title || primary.name;
    return (
      <div className={"d-flex flex-column w-100 header-item-container-" + detailTitle.toLowerCase().replace(" ", "-")}>
        <p className="stat-name primary-header" title={tooltip || (primaryCompData || {}).title}>
          {detailTitle}
        </p>
        {primaryComparison}
        {userNote}
        <div className="mt-auto">{detailRows}</div>
      </div>
    );
  }
}

export default RUMDataDetail;
